module.exports = __webpack_public_path__ + "img/registration-success.43da2f9d.png";